module.exports = __webpack_public_path__ + "static/media/DqEveryChildWorkshopCampaignPresentation.3f80c12a.jpg";